@if (showHistoryButton()) {
    <app-history-button [attr.data-qa]="qaTag() + '-header-history-button'" [customHistoryBackAction]="historyBackAction()" [isHistoryCloseButton]="hasHistoryCloseButton()"
                        class="header-history-button"/>
}
@if (title()) {
    <h1 [attr.data-qa]="qaTag() + '-header-text'" class="header-text">{{ title() }}</h1>
}
<ng-content/>
